import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

// v2 column brick option "Spalten als Slider auf Mobile": below tablet the columns become a swiper,
// from tablet on the swiper is destroyed again and the normal columns are shown
class MobileSlider {
  constructor() {
    this.containers = document.querySelectorAll('.js-mobile-slider');
    this.mediaQuery = window.matchMedia('(max-width: 768px)');
  }

  init() {
    if (this.containers.length > 0) {
      this.update();
      this.mediaQuery.addEventListener('change', () => this.update());
    }
  }

  update() {
    this.containers.forEach((container) => {
      if (this.mediaQuery.matches) {
        this.create(container);
      } else {
        this.destroy(container);
      }
    });
  }

  create(container) {
    const wrapper = container.querySelector(':scope > .columns');

    if (container.swiper || !wrapper) return;

    container.classList.add('swiper');
    wrapper.classList.add('swiper-wrapper');
    wrapper.querySelectorAll(':scope > .column').forEach((column) => {
      column.classList.add('swiper-slide');
    });

    new Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: container.querySelector('.swiper-pagination'),
        clickable: true,
      },
      modules: [Pagination],
    });
  }

  destroy(container) {
    const wrapper = container.querySelector(':scope > .columns');

    if (!container.swiper || !wrapper) return;

    container.swiper.destroy(true, true);
    container.classList.remove('swiper');
    wrapper.classList.remove('swiper-wrapper');
    wrapper.querySelectorAll(':scope > .column').forEach((column) => {
      column.classList.remove('swiper-slide');
    });
  }
}

export default new MobileSlider();
